import initialState from './initial.state';
import * as types from '../actions/types.action';
import {DEFAULT_HEADER_COLOR} from '../constants/constant';

export default function templateReducer(state = initialState.template, action) {
  switch (action.type) {
    case types.CHANGE_TEMPLATE_SUCCESS:
      if (!action.template.name || !action.template.headerColour) {
        return Object.assign({}, action.template, {
          name: action.template.name || 'dark',
          headerColour: action.template.headerColour || DEFAULT_HEADER_COLOR,
          navigationMenu: action.template.navigationMenu
        });
      }
      return action.template;
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./reducers/template.reducer.js